<div class="my-md-view-wrapper">
  <app-node-path class="my-md-view__node-path" [nodePath]="nodePath$ | async"></app-node-path>
  <q9-grid
    [filterable]="false"
    [sortable]="false"
    [columns]="columns$ | async"
    [selectBy]="idField"
    [enableMultiSelect]="false"></q9-grid>
</div>
